import { api } from '../config/base-api';

interface GetCitiesParams {
  country: string;
  brand: string;
  region: string;
  recurringSaleAllowed?: boolean;
}

export interface GetCitiesResponse {
  brand: string;
  country: string;
  region: string;
  city: string;
}

export async function getCities({
  brand,
  country,
  region,
  recurringSaleAllowed,
}: GetCitiesParams): Promise<GetCitiesResponse[]> {
  const res = await api.get<GetCitiesResponse[]>('/api/v1/franchises/cities', {
    params: {
      brand,
      country,
      region,
      ...(recurringSaleAllowed !== undefined && { recurringSaleAllowed }),
    },
  });

  return res.data;
}
